// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"e2e913e7","453":"3e64e4cf"}[chunkId] + ".chunk.js";
};